import React from "react";
import { Linkedin, Facebook, Instagram, Youtube } from "lucide-react";

// Custom X (Twitter) and TikTok icons — lucide-react ships an old "Twitter"
// bird; we want the modern X mark and a real TikTok glyph.
export const XIcon = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25h6.838l4.713 6.231 5.439-6.231Zm-1.16 17.52h1.833L7.084 4.126H5.117L17.084 19.77Z" />
  </svg>
);

export const TikTokIcon = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className}>
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.32 20.1a6.34 6.34 0 0 0 10.86-4.43V8.95a8.16 8.16 0 0 0 4.77 1.52V7a4.85 4.85 0 0 1-1.36-.31Z" />
  </svg>
);

// Single source of truth for the Startup Otter social presence. Imported by
// both the public Footer and the Contact page so the lists never drift.
export const SOCIALS = [
  { href: "https://facebook.com/StartupOtter", label: "Facebook", testId: "social-facebook", Icon: Facebook },
  { href: "https://x.com/StartupOtter", label: "X", testId: "social-x", Icon: XIcon },
  { href: "https://linkedin.com/company/StartupOtter", label: "LinkedIn", testId: "social-linkedin", Icon: Linkedin },
  { href: "https://instagram.com/StartupOtter", label: "Instagram", testId: "social-instagram", Icon: Instagram },
  { href: "#", label: "TikTok (coming soon)", testId: "social-tiktok", Icon: TikTokIcon, disabled: true },
  { href: "#", label: "YouTube (coming soon)", testId: "social-youtube", Icon: Youtube, disabled: true },
];
